<template>
  <v-list-item @click.stop="isAuthenticated ? signOut() : signIn()">
    <v-list-item-action>
      <v-icon color="accent" x-large>
        {{ isAuthenticated ? 'mdi-logout' : 'mdi-login' }}
      </v-icon>
    </v-list-item-action>
    <v-list-item-title class="text-h6">
      {{ isAuthenticated ? $t('account.signout') : $t('account.signin') }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import { isPWA } from '@/pwa.js'

export default {
  name: 'SignInOutMenuItem',

  components: {},

  data: function () {
    return {}
  },

  computed: {
    domain() {
      return this.$store.state.tenantStore.tenant.domain
    },

    locale() {
      return this.$store.state.i18nStore.locale
    },

    isAuthenticated() {
      return this.$auth.isAuthenticated()
    },

    realmType() {
      return this.$store.state.tenantStore.tenant.realmType
    },

    logoutRedirectURI() {
      const uri = {
        private: isPWA() ? '/close?reason=exit' : '/close',
        protected: '/susi',
        public: '/'
      }
      return uri[this.realmType] || '/close'
    }
  },

  mounted: function () {},

  activated: function () {},

  methods: {
    signIn() {
      const options = {
        domainHint: this.domain,
        locale: this.locale,
        state: {
          redirectURI: this.$route.path
        }
      }
      this.$auth.signIn(options)
    },

    signOut() {
      const options = {
        redirectURI: this.logoutRedirectURI
      }
      this.$auth.signOut(options)
    }
  }
}
</script>

<style lang="css" scoped>
.c-list-group .v-list-item--active.theme--dark {
  color: white !important;
}
.c-list-group .v-list-item--active.theme--light {
  color: black !important;
}
</style>
